const customer = [{
  desc: '公告、核保列表查询',
  options: {
    url: '/notice/queryNotices',
    method: 'post'
  }
}, {
  desc: '查询重要公告',
  options: {
    url: '/notice/querySystemNotices',
    method: 'post'
  }
}, {
  desc: '政策公告查询',
  options: {
    url: '/notice/queryPolicyNotices',
    method: 'post'
  }
}, {
  desc: '添加公告、核保公告',
  options: {
    url: '/notice/addNotice',
    method: 'post'
  }
/* }, {
  desc: '根据当前商户查询角色',
  options: {
    url: '/role/queryRolesBySysVersion',
    method: 'post'
  } */
}, {
  desc: '删除公告',
  options: {
    url: '/notice/deleteNotice',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '编辑公告',
  options: {
    url: '/notice/updateNotice',
    method: 'post'
  }
}, {
  desc: '查询已发布的系统公告',
  options: {
    url: '/notice/querySystemNoticesForReleased',
    method: 'post'
  }
}, {
  desc: '批量更新弹窗提醒',
  options: {
    url: '/notice/batchUpdateSystemNotice',
    method: 'post'
  }
}, {
  desc: '添加系统公告查看记录',
  options: {
    url: '/notice/addSystemNoticeDetail',
    method: 'post'
  }
}]
export default customer



// WEBPACK FOOTER //
// ./src/api/announcement.js